import React, { createContext, useContext } from 'react'

export interface CoachGraceOpenChatOptions {
  dynamicVariables?: Record<string, string>
  initialUserMessage?: string
  overridePrompt?: string
  overrideFirstMessage?: string
  overrideTextOnly?: boolean
}

interface CoachGraceContextType {
  openChat: (options?: CoachGraceOpenChatOptions) => void
}

export const COACH_GRACE_OPEN_EVENT_NAME = 'coach-grace:open-chat'

function openCoachGraceChat(options?: CoachGraceOpenChatOptions) {
  document.dispatchEvent(
    new CustomEvent<CoachGraceOpenChatOptions>(COACH_GRACE_OPEN_EVENT_NAME, { detail: options }),
  )
}

const defaultContextValue: CoachGraceContextType = {
  openChat: openCoachGraceChat,
}

const CoachGraceContext = createContext<CoachGraceContextType>(defaultContextValue)

export function CoachGraceProvider({ children }: { children: React.ReactNode }) {
  return <CoachGraceContext.Provider value={defaultContextValue}>{children}</CoachGraceContext.Provider>
}

export function useCoachGrace() {
  return useContext(CoachGraceContext)
}
